
<app-login-base pageHeader="Reset Password">
    <form #resetPasswordForm="ngForm" (ngSubmit)="ResetPassword()">
        <!-- Email -->
            <div class="md-form input-white">
            <div class="input-group">
                <div class="input-container">
                    <input 
                        type="email" 
                        id="resetEmail" 
                        class="form-control auto-bottom-margin"
                        mdbInput
                        mdbValidate
                        name="email"      
                        #email="ngModel"                              
                        required
                        [(ngModel)]="emailAddress"
                        [pattern]="emailRegExpression"
                    />
                    <label for="resetEmail">E-mail</label>
                    <mdb-error class="p-1" *ngIf="email.invalid && (email.dirty || email.touched)">Please ensure email address is valid</mdb-error>
                </div>
            </div>
        </div>  

        <div class="d-flex justify-content-around">            
            <div class="col-sm-10 col-md-8">
                <button *ngIf="!busy" mdbBtn color="dooya" block="true" class="my-4" type="submit">Reset</button>
                <app-loading [busy]="busy"></app-loading>
            </div>
        </div>

        <div class="d-flex justify-content-around my-2">                                
            <a routerLink="/"  routerLinkActive="active">Back to Login</a>                               
        </div>

        <!--Error Display-->
        <div *ngIf="showError" class="alert alert-danger" role="alert">
        {{ errorMsg }}
        </div>

        <!--Success Display-->
        <div *ngIf="showSuccess" class="alert alert-success" role="alert">
            If an account exists for that email, a one-time password has been sent. Redirecting...
        </div>
    </form>
</app-login-base>
                    
     